module.exports = __webpack_public_path__ + "img/maas_wrapbg3.35f6c099.png";